"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Auth0 = void 0;
var Auth0;
(function (Auth0) {
    Auth0[Auth0["BadRequest"] = 400] = "BadRequest";
    Auth0[Auth0["Unauthorized"] = 401] = "Unauthorized";
    Auth0[Auth0["Forbidden"] = 403] = "Forbidden";
    Auth0[Auth0["NotFound"] = 404] = "NotFound";
    Auth0[Auth0["MethodNotAllowed"] = 405] = "MethodNotAllowed";
    Auth0[Auth0["TooManyRequests"] = 429] = "TooManyRequests";
    Auth0[Auth0["InternalServerError"] = 500] = "InternalServerError";
    Auth0[Auth0["NotImplemented"] = 501] = "NotImplemented";
    Auth0[Auth0["ServiceUnavailable"] = 503] = "ServiceUnavailable";
})(Auth0 = exports.Auth0 || (exports.Auth0 = {}));
//# sourceMappingURL=auth0.js.map